module.exports = {
  currency: 'OMR',
  useLegacyFilter: true,
  languages: [
    { name: 'English', code: 'en', rtl: false },
    { name: 'Arabic', code: 'ar', rtl: true },
  ],      
  general: {
    fontFamily: {
      en: 'GE Dinkum',
      ar: 'GE Dinkum'
    },
    showArtistImpressionText: false,
    showOnHoldGraphic: true,
    showSoldPrice: false,
    showHomeButton: true,
    canInteractSoldLivingOptions: true,
    canInteractSoldSubsections: true,
    canInteractSoldProperties: true,
    showSoldNeighbourhoods: true,
    showSoldReleases: true,    
    disclaimer: 'Content or information obtained from Sensoreal is accurate, complete or reliable at time of publishing. Information about land, homes, apartments, and land and house package prices. This information is to be used as a guide only. Any images and diagrams on the website should be used as a visual aid only and may not accurately reflect the development, the land and/or the house referred to or depicted. We may, from time to time and without notice, change or add to the Sensoreal or the information, products or services described in it.'
  },
  filter: {
    dwellings: {
      houseDesign: false
    }
  },
  landPage: {
    active: false
  },

  property_card: {
    price_label: {
      house_design: 'House Price From'
    }
  },

  property_modal: {
    show_suitable_dwellings_button: true
  },

  rightSidebar: {
    propertyGuide: {
      active: true,
      items: [
        'Available',
        'On Hold',
        'Sold'
      ]
    }
  },
  useSidebarSubnavigation: true,
  labels: {
    exploreCommunities: {
      en: 'Explore Communities',
      ar: 'استكشاف المجتمعات'
    },
    builder: {
      en: 'Developer',
      ar: 'المطور​'
    },
    houseSize: {
      en: 'Home Size',
      ar: 'مسطح البناء',
    },
    beds: {
      en: 'Rooms',
      ar: 'غرف',
    },
    baths: {
      en: 'Baths',
      ar: 'دورات مياه',
    },
    cars: {
      en: 'Parking',
      ar: 'موقف',
    },
    houseDesign: {
      en: 'Type',
      ar: 'النموذج',
    },
    builderDesign: {
      en: 'Builder Design',
      ar: 'تصميم البناء',
    },
    landSize: {
      en: 'Plot Size',
      ar: 'مساحة الأرض',
    },
    description: {
      en: 'Description',
      ar: 'وصف',
    },
    features: {
      en: 'Features',
      ar: 'المواصفات​',
    },
    openingHours: {
      en: 'Opening Hours',
      ar: 'ساعات العمل',
    },
    name: {
      en: 'Name',
      ar: 'اسم'
    },
    label: {
      en: 'Unit No.',
      ar: 'رقم الوحدة'
    },
    price: {
      en: 'Price',
      ar: 'السعر'
    },
    back: {
      en: 'Back',
      ar: 'عُد'
    },
    viewBrochure: {
      en: 'View Brochure',
      ar: 'عرض الكتيّب'
    },
    viewLabel: {
      en: 'View',
      ar: 'الإطلالة'
    },
    closeBrochure: {
      en: 'Close Brochure',
      ar: 'إخفاء الكتيب'
    },
  },
}